/* eslint-disable */
<template>
  <div
    v-loading="loading"
    @click="handtipshow"
  >
    <div class="opallbox">
      <!-- <div class="optionbox">
        <div class="optiontext">选择平台</div>
        <el-select v-model="platformvalue" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="optionbox">
        <div class="optiontext">选择公众号</div>
        <el-input v-model="officialaccountname" placeholder="请输入公众号名称" style="margin-right:10px" />
        <el-button type="primary" @click="determine">确定公众号</el-button>
      </div>
      <div class="optionbox">
        <div class="optiontext">发送日期</div>
        <el-date-picker
          v-model="sendata"
          type="date"
          placeholder="选择日期"
        />
      </div>
      <div class="optionbox">
        <div class="optiontext">阅读类型</div>
        <el-select v-model="readtype" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="optionbox">
        <div class="optiontext">书籍名称</div>
        <el-input v-model="bookname" placeholder="请输入书籍名称" style="margin-right:10px" />
      </div>
      <div class="optionbox">
        <div class="optiontext">渠道名称</div>
        <el-input v-model="channelname" placeholder="请输入渠道名称" style="margin-right:10px" />
      </div>
      <div class="optionbox">
        <div class="optiontext">书籍章节</div>
        <el-input v-model="booknum" placeholder="请输入书籍章节" style="margin-right:10px" />
      </div> -->
      <div class="chawepalite">
        <div class="optiontext">选择平台</div>
        <el-select v-model="platformvalue" placeholder="请选择" @change="plateall">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </div>
      <div class="optionbox">
        <div class="optiontext">标题</div>
        <el-input v-model="bigtitle" placeholder="请输入大标题" style="margin-right:10px" />
      </div>
    </div>
    <div class="title_vor">*涉及到AB号请选择通用平台,在每篇文章选择对应的平台,变更平台会清空当前所填写的内容</div>

    <div class="editbox">
      <div class="leftbox">
        <div v-for="item,index in arr" :key="index" :class="[item.id===active?'updataactive':'',index === 0 ? 'updatabox' : 'updatabox1']" @click.stop="activeclick(item.id,index)">
          <span :class="[index === 0?'spanbox':'spanbox1']">
            {{ item.title }}
          </span>
          <div :style="{backgroundImage: 'url('+item.srv+')'}" :class="[index === 0?'backrbox':'backrbox1']">
          <!-- <img :src="item.srv" class="srvbox" alt=""> -->
          </div>

          <div v-show="item.showtips" class="ciclebox">
            <div class="tiparrowbox">
              <!-- 删除 -->
              <img v-show="index !== 0" src="@/assets/larke/delte3.png" style="width:20px;height:20px;margin-bottom:10px" alt="" @click.stop="deleteitem(index)">
              <!-- <i v-show="index !== 0" class="el-icon-delete tipicon" @click.stop="deleteitem(index)" /> -->
              <!-- 向下 -->
              <img v-show="index !== arr.length-1" src="@/assets/larke/delte2.png" style="width:20px;height:20px;margin-bottom:10px" alt="" @click.stop="downGo(index)">
              <!-- <i v-show="index !== arr.length-1" class="el-icon-bottom tipicon" @click.stop="downGo(index)" /> -->
              <!-- 向上 -->
              <img v-show="index !== 0" src="@/assets/larke/delte1.png" style="width:20px;height:20px;margin-bottom:10px" alt="" @click.stop="upGo(index)">
              <!-- <i v-show="index !== 0" class="el-icon-top tipicon" @click.stop="upGo(index)" /> -->
              <!-- 更换 -->
              <!-- <i v-show="index === 0" class="el-icon-sort tipicon" /> -->
              <!-- 导入链接按钮 -->
              <img src="@/assets/larke/delte4.png" style="width:25px;height:25px;margin-bottom:10px" alt="" @click.stop="importclick">
              <!-- <i class="el-icon-document tipicon" @click.stop="importclick" /> -->

            </div>
          </div>
        </div>

        <div
          v-if="arr.length<8"
          class="addbox"
          @mouseenter="mouseenter"
          @mouseleave="mouseleave"
          @click="mouseenter"
        >
          <span>+新建消息</span>
          <div v-show="tips" class="tipbox">
            <div @click="addImageText">写新图文</div>
          <!-- <div @click="addvideo">视频消息</div>
            <div @click="addvoice">音频消息</div> -->
          </div>
        </div>
      </div>
      <div class="centerbox">
        <el-select v-if="platformvalue == 99" v-model="arr[indexinput].item_platform_id" placeholder="请选择平台" style="margin-bottom:15px" @change="sewrwx">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <el-input v-model="arr[indexinput].title" class="centerinput" placeholder="标题" />

        <el-input v-if="arr[indexinput].type == 'txt'" v-model="arr[indexinput].author" placeholder="作者(最多为8个字符)" maxlength="8" />

        <el-input
          v-if="arr[indexinput].type == 'voice'"
          v-model="arr[indexinput].recommend"
          type="textarea"
          :rows="2"
          placeholder="可以输入140字以内的推荐语(选填)"
        />
        <audio v-if="arr[indexinput].type == 'voice'" controls controlslist="nodownload" class="viewrw">
          <source :src="arr[indexinput].voiceurl" type="audio/mp3">
        </audio>
        <!-- <tinymce v-model="arr[indexinput].content" :height="300" />
        <div v-html="arr[indexinput].content" /> -->
        <div v-if="arr[indexinput].type == 'txt'" style="margin-top:10px">
          <!-- <el-button type="primary" size="mini" @click="$refs.file.click()">上传<input ref="file" style="display:none;" type="file" multiple accept="image/gif,image/jpg,image/jpeg,image/png" @change="uploadPictures"></el-button> -->
          <!-- <el-button type="primary" size="mini" @click="updatapic">上传图片</el-button> -->
          <el-button type="primary" size="mini" @click="chaweimg">插入图片</el-button>

          <!-- <el-button type="primary" size="mini" @click="choosevideos">视频</el-button>
          <el-button type="primary" size="mini" @click="choosevoices">音频</el-button> -->
          <el-button type="primary" size="mini" @click="chawechat">插入小程序</el-button>
        <!-- <el-button type="primary" size="mini">超链接</el-button> -->
        </div>
        <div v-if="arr[indexinput].type == 'txt'" style="border: 1px solid #ccc; margin:10px 0px">
          <!-- <tinymce-editor
            ref="editor"
            v-model="arr[indexinput].content"
            :disabled="disabled"
            :base-url="baseUrl"
            :language="language"
            :skin="skin"
            @onClick="onClick"
          /> -->

          <!-- 工具栏 -->
          <!-- <Toolbar
            style="border-bottom: 1px solid #ccc"
            :editor="editor"
            :default-config="toolbarConfig"
          /> -->
          <!-- 编辑器 -->
          <!-- <Editor
            v-model="arr[indexinput].content"
            style="height: 400px; overflow-y: hidden;"
            :default-config="editorConfig"
            @onChange="onChange"
            @onCreated="onCreated"
          /> -->
          <Editor-wang ref="editorwangfour" v-model="arr[indexinput].content" />
        <!-- <div style="margin-top: 10px;">
            <textarea
              v-model="arr[indexinput].content"
              readonly
              style="width: 100%; height: 200px; outline: none;"
            />
          </div> -->
        <!-- <button @click="clear">清空内容</button>
          <button @click="disabled = true">禁用</button>
          <button @click="disabled = false">启用</button> -->
        </div>
        <!-- 底部图片 -->
        <div v-if="arr[indexinput].type == 'txt' && arr[indexinput].bottom_qr_code === 1" class="">
          <img class="bottom_qrcode" :src="arr[indexinput].bottomitensrc" alt="">
        </div>
        <div v-if="arr[indexinput].type == 'txt' && arr[indexinput].bottom_guide!=''" style="position: relative;">
          <div v-html="arr[indexinput].bottom_guide" />
          <div v-if="arr[indexinput].bottom_guide!=null && arr[indexinput].bottom_guide!=''" class="delter_icon" @click.stop="deleterclick"><i class="el-icon-delete" /></div>
        </div>

        <div style="margin-bottom: 10px;">
          <el-radio-group v-model="arr[indexinput].original_link_type">
            <el-radio-button :label="1">h5链接</el-radio-button>
            <el-radio-button :label="2">小程序</el-radio-button>
          </el-radio-group>
        </div>
        <div class="choosecover" style="margin-bottom:20px;cursor: pointer;">
          <!-- arr[indexinput].content_source_url -->
          <!-- <el-input v-if="arr[indexinput].type == 'txt' && arr[indexinput].switch == 1" v-model="generatedUrl" disabled placeholder="原文链接" style="width:500px" />
          <el-input v-if="arr[indexinput].type == 'txt' && arr[indexinput].switch == 2" v-model="arr[indexinput].content_source_url" :disabled="arr[indexinput].next_chapters_url === 1" placeholder="原文链接" style="width:500px" /> -->
          <el-input v-if="arr[indexinput].type == 'txt' && arr[indexinput].original_link_type == 1" v-model="arr[indexinput].content_source_url" placeholder="原文链接" style="width:500px" :disabled="arr[indexinput].next_chapters_url === 1" />
          <div v-if="arr[indexinput].type == 'txt' && arr[indexinput].original_link_type == 1" class="choosecover">
            <!-- <div class="text_wei">
              添加链接活动：
            </div> -->
            <!-- <el-tag @click="addbookactivey">添加书城活动</el-tag> -->
            <div @click="beforehandleCommand">
              <el-dropdown trigger="click" style="margin-left:10px;cursor: pointer;" @command="handleCommand">
                <span class="el-dropdown-link">
                  添加链接活动<i class="el-icon-arrow-down el-icon--right" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item,index) in linkallarr" :key="index" :command="beforeHandleCommand(item.sign,item.identification,1)">{{ item.type_name }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
        <div v-if="arr[indexinput].type == 'txt' && arr[indexinput].original_link_type == 2" style="margin-bottom:20px">
          <div style="display: flex;align-items: center;margin-bottom: 10px;">
            <el-input v-model="arr[indexinput].original_link_mini_program_id" style="width: 460px;" placeholder="小程序appid（小程序务必授权在运营系统）" :disabled="arr[indexinput].next_chapters_url === 1 || arr[indexinput].mobool == 1" />
            <div>
              <el-radio-group v-model="arr[indexinput].mobool" style="margin-left: 5px;" @change="grounpmoll">
                <el-radio-button :label="1">默认</el-radio-button>
                <el-radio-button :label="2">不默认</el-radio-button>
              </el-radio-group>
            </div>
          </div>
          <div>
            <div style="display: flex;align-items: center;">
              <el-input v-model="arr[indexinput].original_link_mini_program_path" placeholder="小程序跳转路径path" :disabled="arr[indexinput].next_chapters_url === 1" style="width: 460px;" />
              <div v-if="Array.isArray(wechatlinkallarr) && wechatlinkallarr.length > 0" @click="beforehandleCommand">
                <el-dropdown
                  trigger="click"
                  :style="{
                    marginLeft: '10px',
                    cursor: Array.isArray(wechatlinkallarr) && wechatlinkallarr.length > 0 ? 'pointer' : 'default'
                  }"
                  @command="handleCommand"
                >
                  <span class="el-dropdown-link">
                    添加链接活动<i class="el-icon-arrow-down el-icon--right" />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item,index) in wechatlinkallarr" :key="index" :command="beforeHandleCommand(item.sign,item.identification,2)">{{ item.type_name }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
        </div>
        <!-- <div style="margin-bottom: 10px;display: flex;align-items: center;">
          <div>h5跳小程序：</div>
          <el-switch
            v-model="arr[indexinput].switch"
            style="display: block"
            :active-value="1"
            :inactive-value="2"
            active-text="开"
            inactive-text="关"
            @change="chanswitch"
          />
        </div> -->
        <!-- <div v-if="arr[indexinput].type == 'txt' && arr[indexinput].switch == 1" style="display: flex;align-items: center;margin-bottom: 10px;">
          <div style="flex-shrink: 0;">appid：</div>
          <el-input v-model="arr[indexinput].app_id" placeholder="小程序appid（小程序务必授权在运营系统）" @blur="removeAllSpaces" />
        </div>
        <div v-if="arr[indexinput].type == 'txt' && arr[indexinput].switch == 1" style="display: flex;align-items: center;margin-bottom: 10px;">
          <div style="flex-shrink: 0;">地址：</div>
          <el-input v-model="arr[indexinput].path" placeholder="小程序跳转路径path" @blur="removeAllSpacestwo" />
        </div> -->

        <div class="fansbox">
          <div class="sdawr">是否打开评论</div>
          <el-switch
            v-model="arr[indexinput].need_open_comment"
            active-text="开"
            inactive-text="关"
            :active-value="1"
            :inactive-value="0"
          />
        </div>
        <div class="fansbox">
          <div class="sdawr">是否粉丝才可评论</div>
          <el-switch
            v-model="arr[indexinput].only_fans_can_comment"
            active-text="开"
            inactive-text="关"
            :active-value="1"
            :inactive-value="0"
          />
        </div>

        <div v-if="arr[indexinput].type == 'txt'" class="setting-group__title">封面和摘要</div>
        <!-- 封面和摘要div -->
        <div v-if="arr[indexinput].type == 'txt'" class="abstractbox">
          <div class="chooseicon" @click="chooseiconclcik">
            <i class="el-icon-plus iconplus" />
            <div class="btn-text">选择封面</div>
            <div :style="{backgroundImage: 'url('+arr[indexinput].srv+')'}" class="select-cover__preview" />
          </div>

          <el-input
            v-model="arr[indexinput].digest"
            class="textfield"
            type="textarea"
            placeholder="选填，摘要会在订阅号消息、转发链接等文章外的场景显露，帮助读者快速了解内容，如不填写则默认抓取正文前54字"
            :autosize="{ minRows: 3.7}"
            maxlength="120"
            show-word-limit
          />

        </div>

        <el-button type="primary" class="btne" @click="go">提交</el-button>
      </div>

      <div>
        <!-- <div class="optionbox">
          <div class="optiontext">选择平台：</div>
          <el-select v-model="obj.platformvalue" placeholder="请选择" @change="chooseplate">
            <el-option
              v-for="item in palarr"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </div> -->
        <div class="optionbox">
          <div class="optiontext">选择书籍：</div>
          <el-tag v-if="obj.bookname!=''" style="margin-right:10px">{{ obj.bookname }}</el-tag>
          <el-button type="primary" size="mini" :disabled="platformvalue === 99 && arr[indexinput].item_platform_id === '' || platformvalue===null ? true : false" @click="choosebookid">选择书籍</el-button>
        </div>
        <div class="optionbox">
          <div class="optiontext">选择章节：</div>
          <el-tag v-if="obj.chaptername!=''" style="margin-right:10px">{{ obj.chaptername }}</el-tag>
          <el-button type="primary" size="mini" :disabled="obj.bookid==null" @click="chapterclick">选择章节</el-button>
        </div>
        <div class="optionbox">
          <el-button type="primary" size="mini" @click="choserauth(1)">生成推广文案</el-button>
          <el-button type="primary" size="mini" @click="choserauth(2)">生成推广图片</el-button>
        </div>
        <div class="optionbox">
          <div class="optiontext">使用<el-select v-model="arr[indexinput].chapter_typer" style="margin: 0px 10px;width: 100px;" placeholder="请选择" @change="chapterwer">
            <el-option
              v-for="item in alloptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />

          </el-select>
          </div>
          <div>
            为原文链接：
            <el-radio-group v-model="arr[indexinput].next_chapters_url" size="small" @change="nextchat">
              <el-radio-button :label="1" :disabled="obj.chaptername === ''">使用</el-radio-button>
              <el-radio-button :label="2">不使用</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="optionbox">
          <div class="optiontext">底部二维码：</div>
          <div>
            <el-radio-group v-model="arr[indexinput].bottom_qr_code" size="small" @click="choseqrcode">
              <el-radio-button :disabled="obj.chaptername === '' && obj.bookname === ''" :label="1">显示</el-radio-button>
              <el-radio-button :label="2">隐藏</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div v-if="arr[indexinput].bottom_qr_code === 1" class="bottom_box">
          <div v-for="item,index in bottomarr" :key="index" @click="choosebottom(item,index)">
            <img :src="item.template_image_url" alt="" class="bottom_itembox" :class="{bottom_Light: whichIndex == index}">
          </div>
        </div>
      </div>
    </div>

    <!-- 上传图片弹窗 -->
    <el-dialog
      title="图片库"
      :visible.sync="dialogVisible"
      style="padding-left: 60px;padding-top: 15px;"
    >
      <chooseimg ref="mychild" :imgarr="imgarr" @clickicon="clickicon" @clickicongon="clickicongon" />
    </el-dialog>
    <!-- 上传音频弹窗 -->
    <el-dialog
      title="音频库"
      :visible.sync="voicedialogVisible"
      :destroy-on-close="true"
    >
      <choosevoice ref="voicedialog" @btnclcik="btnclcik" />
    </el-dialog>
    <!-- 上传视频弹窗 -->
    <el-dialog
      title="视频库"
      :visible.sync="videodialogVisible"
      :destroy-on-close="true"
    >
      <choosevideo ref="videodialog" @callvideo="callvideo" />
    </el-dialog>
    <!-- vueCropper 剪裁图片实现 弹窗-->
    <el-dialog title="图片剪裁" :visible.sync="caidialogVisible" append-to-body>
      <el-radio-group v-model="radiosize" style="margin-bottom:10px" @change="radiochangew">
        <el-radio :label="1">图文封面（2.35:1）</el-radio>
        <el-radio :label="2">图文封面（1:1）</el-radio>
      </el-radio-group>
      <div class="cropper-content">
        <div class="cropper" style="text-align:center">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :output-size="option.size"
            :info="true"
            :full="option.full"
            :can-move="option.canMove"
            :can-move-box="option.canMoveBox"
            :original="option.original"
            :auto-crop="option.autoCrop"
            :fixed="option.fixed"
            :center-box="option.centerBox"
            :info-true="option.infoTrue"
            :fixed-box="option.fixedBox"
            :auto-crop-width="option.autoCropWidth"
            :auto-crop-height="option.autoCropHeight"
            :fixed-number="option.fixedNumber"
            :enlarge="option.enlarge"
            :mode="option.mode"
          />
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="finish">确认</el-button>
        <el-button @click="quxiao">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="选择小程序"
      :visible.sync="choicedialogVisible"
      :append-to-body="true"
      :modal-append-to-body="true"
      :destroy-on-close="true"
    >
      <choiceaplet @callback="callback" />
    </el-dialog>

    <el-dialog
      title="选择图片"
      :visible.sync="choicedialogVisibleimg"
      :append-to-body="true"
      :modal-append-to-body="true"
      :destroy-on-close="true"
    >
      <selectImage @callbackimgs="callbackimgs" />
    </el-dialog>
    <!-- 书城活动列表 -->
    <el-dialog title="选择活动" :visible.sync="bookctyactivitiesVisible" append-to-body>
      <bookctyactivities ref="bookctyactivitiesbox" @callbadwr="callbadwr" />
    </el-dialog>
    <!-- 发红包活动列表 -->
    <el-dialog title="选择红包" :visible.sync="redbao" append-to-body>
      <reddialog ref="chooseredbao" @redcallback="redcallback" />
    </el-dialog>
    <!-- 书城链接活动 -->
    <el-dialog title="选择书城链接" :visible.sync="sclink" append-to-body>
      <booklinkdialog ref="sclinkview" @sclinkcallback="sclinkcallback" />
    </el-dialog>
    <el-dialog
      title="选择书籍"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="dialogVisibler"
      :destroy-on-close="true"
    >
      <bookdialog ref="chooseviewr" @callback="bookcallbackr" />
    </el-dialog>
    <el-dialog
      title="选择章节"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="chapterdialogVisibler"
      :destroy-on-close="true"
    >
      <chapterdialog ref="chapterviewr" @chaptercallback="bookchaptercallback" />
    </el-dialog>
    <el-dialog
      title="导入链接文章"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="importlinkdialog"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <importlink ref="importlinkview" @callbackcontent="callbackcontent" @callbacktitle="callbacktitle" @callbackimg="callbackimg" @callcloser="callcloser" />
    </el-dialog>

    <el-dialog
      title="选择书籍链接活动"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="bookdialivler"
      :destroy-on-close="true"
    >
      <choosebookdialog ref="choosebookdialogview" @callchoooseter="callchoooseter" />
    </el-dialog>
    <div class="editdraw">
      <el-drawer
        v-if="dialogVisible1"
        :title="choserauthtype === 1 ? '推广文案' : '推广图片'"
        :visible.sync="dialogVisible1"
        size="80%"
        @close="dialogVisible1 = false"
      >
        <sundialog v-if="choserauthtype == 1" ref="sundialogview" @callbackcontent="callbackcontent" @callbacktitle="callbacktitle" @callbackimg="callbackimg" @callbackbottom="callbackbottom" />
        <yuwendialog v-if="choserauthtype == 2" ref="yuwendialogview" @callbackcontent="callbackcontent" @callbacktitle="callbacktitle" @callbackimg="callbackimg" @callbackbottom="callbackbottom" />
      </el-drawer>
    </div>

  </div>

</template>

<script>
// import Tinymce from '@/components/Tinymce'
// import TinymceEditor from '@/components/tinymce-editor/tinymce-editor'
import chooseimg from './components/chooseimgone.vue'
import selectImage from './components/selectImage.vue'
import choosevoice from './components/choosevoice.vue'
import choosevideo from './components/choosevideo.vue'
import choiceaplet from './components/choiceaplet.vue'
import sundialog from './components/sundialog.vue'
import yuwendialog from './components/yuwendialog.vue'
import * as qiniu from 'qiniu-js'
import { qiniuToken } from '@/api/qiniuToken.js'
// import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import EditorWang from './components/AboutView.vue'
import { newMaterial, officialaccount, editaccount, strategyPlatform, strategyPlatformtwo, /* promotiondocument */ getlinktypeslist, articleDetail, getBottomImageTemplate, novellist, createtemplate } from '@/api/sourceMaterial.js'
import bookctyactivities from '../customerService/components/bookctyactivities.vue'
import reddialog from '../customerService/components/reddialog.vue'
import booklinkdialog from '../customerService/components/booklinkdialog.vue'
import bookdialog from '../extensionlink/components/bookdialog.vue'
import chapterdialog from '../extensionlink/components/chapterdialog.vue'
import importlink from './components/importlink.vue'
import choosebookdialog from './components/bookdialog.vue'
export default {
  // name: 'AccountPush',
  components: {
    // Tinymce,
    // TinymceEditor,
    chooseimg,
    choosevoice,
    choosevideo,
    // Editor,
    // Toolbar,
    choiceaplet,
    bookctyactivities,
    reddialog,
    booklinkdialog,
    bookdialog,
    chapterdialog,
    EditorWang,
    sundialog,
    yuwendialog,
    importlink,
    selectImage,
    choosebookdialog
  },
  data() {
    return {
      loading: false,
      disabled: false,
      baseUrl: './',
      language: 'zh_CN',
      skin: 'oxide',
      bigtitle: '',
      arr: [
        {
          item_platform_id: '',
          id: Math.random(), // id
          type: 'txt', // 类型
          img: '', // 图片
          title: '标题', // 标题
          author: '', // 作者
          content: '', // 富文本框的内容
          showtips: true, // tip框的显示隐藏
          srv: '', // 上传封面图
          thumb_media_id: '', // 上传封面图id
          digest: '', // 封面图的摘要
          content_source_url: '', // 原文链接
          need_open_comment: 0, // 是否打开评论，0不打开(默认)，1打开
          only_fans_can_comment: 0, // 是否粉丝才可评论，0所有人可评论(默认)，1粉丝才可评论

          book_title: '', // 选择书籍的书籍名称
          chapter_name: '', // 章节名称
          bottom_qr_code: 2, // 底部图显示以及隐藏
          bottomitensrc: '', // 底部图片地址
          book_id: null, // 书籍id
          chapters_id: null, // 当前章节id
          next_chapters_id: null, // 下一章节id
          next_chapters_name: '', // 下一章章节名称
          template_image_id: null, // 二维码图片id
          gender: null, // 书籍类型
          chapteridx: null,
          bookids: null,
          next_chapters_url: 2, // 使用下一章为原文链接 1 使用 2不使用
          bottom_guide: '', // 底部图片
          chapter_typer: 2,
          app_id: '',
          path: '',
          switch: 2,
          original_link_type: 1,
          original_link_mini_program_id: '',
          original_link_mini_program_path: '',
          mobool: 1
        }
      ],
      imgarr: [{
        img: 'https://qie-online-sale-qiniu.wsandos.com/meinv.jpg'

      }, {
        img: require('@/assets/larke/larke.png')
      }],
      options: [],
      voicedialogVisible: false, // 音频弹窗
      videodialogVisible: false, // 视频弹窗
      importlinkdialog: false, // 导入链接弹窗
      platformvalue: null, // 选择平台
      officialaccountname: '', // 选择公众号名称
      sendata: '', // 发送日期
      readtype: '', // 阅读类型
      bookname: '', // 书籍名称
      channelname: '', // 渠道名称
      booknum: '', // 书籍章节
      tips: false, // 新建消息显示隐藏
      active: null, // 选中那一项id
      indexinput: null, // 取出来的索引值
      dialogVisible: false, // 选择图片弹窗
      token: null, // 七牛云token
      caidialogVisible: false, // 裁剪的弹窗，
      name: null, // 上传的图片名字
      // 裁剪组件的基础配置option
      option: {
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        // outputType: 'jpeg', // 裁剪生成图片的格式     :output-type="option.outputType"
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 200, // 默认生成截图框宽度
        autoCropHeight: 300, // 默认生成截图框高度
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [2.35, 1], // 截图框的宽高比例
        full: false, // 是否输出原图比例的截图
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        enlarge: 1, // 图片根据截图框输出比例倍数
        mode: 'auto 50%' // 图片默认渲染方式  contain , cover, 100px, 100% auto
      },
      editor: null,
      html: '<p>hello&nbsp;world</p>',
      toolbarConfig: {
        // toolbarKeys: [ /* 显示哪些菜单，如何排序、分组 */ ],
        excludeKeys: ['group-image', 'group-video']
      },
      editorConfig: {
        placeholder: '请输入内容...',
        // autoFocus: false,
        pasteFilterStyle: false,
        pasteIgnoreImg: false,
        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {
          // 配置上传图片
          uploadImage: {
            customUpload: this.update
          }
        }
      },
      radiosize: 1,
      edittype: null, // false编辑 true新增
      edittyper: null,
      editid: null, // 编辑时的id
      choicedialogVisible: false,
      choicedialogVisibleimg: false,
      bookctyactivitiesVisible: false,
      redbao: false,
      sclink: false,
      dialogVisibler: false,
      chapterdialogVisibler: false,
      obj: {
        bookname: '', // 书籍名称
        bookid: null, // 书籍id
        gender: null, // 书籍类型
        chaptername: '', // 章节名称
        chapterid: null, // 章节id
        chapteridx: null,
        bookids: null

      },
      palarr: [],
      dialogVisible1: false,
      iframeURL: '',
      linkallarr: [],
      choserauthtype: null,
      accountpusharr: [],
      bottomarr: [],
      whichIndex: -1,
      alloptions: [
        {
          value: 1,
          label: '本章'
        }, {
          value: 2,
          label: '下一章'
        }
      ],
      apiUrl: process.env.VUE_APP_BACKUP_API_URL.replace('api', ''),
      wechatlinkallarr: [],
      custom: '',
      bookdialivler: false
    }
  },
  computed: {
    generatedUrl() {
      return `${this.arr[this.indexinput].content_source_url}${this.arr[this.indexinput].app_id}?path=${this.arr[this.indexinput].path}`
    }
  },
  created(query) {
    console.log('this.apiUrl', this.apiUrl)
    this.bottomlist()
    this.getPlatform()
    this.getPlatformr()
    console.log('query', this.$route.query)

    console.log('edittype', this.edittype)
    this.getQiniuToken()
    this.active = this.arr[0].id
    this.indexinput = 0
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁 editor ，重要！！！
  },
  methods: {
    chaweimg() {
      this.choicedialogVisibleimg = true
    },
    // 获取底部图片
    async bottomlist() {
      // eslint-disable-next-line eqeqeq
      this.edittyper = (JSON.stringify(this.$route.query) == '{}')
      // eslint-disable-next-line eqeqeq
      if (this.edittyper == false) {
        this.loading = true
      }
      const data = await getBottomImageTemplate()
      this.bottomarr = data.data
      // eslint-disable-next-line eqeqeq
      if (data.code == 200) {
        // eslint-disable-next-line eqeqeq
        this.edittype = (JSON.stringify(this.$route.query) == '{}')
        // eslint-disable-next-line eqeqeq
        if (this.edittype == false) {
          this.editid = this.$route.query.id
          this.getinforlist()
        }
      }
    },
    // 获取详情
    async getinforlist() {
      const data = await articleDetail({
        id: this.editid
      })
      if (data.data.articles[0].bottom_qr_code === 1) {
        this.obj.bookname = data.data.articles[0].book_title // 书籍名称
        this.obj.bookid = data.data.articles[0].book_id // 书籍id
        this.obj.gender = data.data.articles[0].gender // 书籍类型
        this.obj.chaptername = data.data.articles[0].chapter_name // 章节名称
        this.obj.chapterid = data.data.articles[0].chapters_id // 章节id
        this.obj.chapteridx = data.data.articles[0].chapteridx
        this.obj.bookids = data.data.articles[0].bookids
      } else {
        this.obj.bookname = data.data.articles[0].book_title // 书籍名称
        this.obj.bookid = data.data.articles[0].book_id // 书籍id
        this.obj.gender = data.data.articles[0].gender // 书籍类型
        this.obj.chaptername = data.data.articles[0].chapter_name // 章节名称
        this.obj.chapterid = data.data.articles[0].chapters_id // 章节id
        this.obj.chapteridx = data.data.articles[0].chapteridx
        this.obj.bookids = data.data.articles[0].bookids
      }
      const indexs = this.bottomarr.findIndex(item => {
        // eslint-disable-next-line eqeqeq
        return item.template_image_id == data.data.articles[0].template_image_id
      })
      if (indexs === -1) {
        console.log('不存在')
        this.whichIndex = -1
      } else {
        this.whichIndex = indexs
      }

      data.data.articles.forEach((item) => {
        // 如果 original_link_type 字段不存在，则默认设为 1
        if (!('original_link_type' in item)) {
          this.$set(item, 'original_link_type', 1)
        }
        if (item.original_link_type === 2) {
          if (!item.original_link_mini_program_id) {
            console.log('kong')
            // item.mobool = null
            // item.mobool = 1
            this.$set(item, 'mobool', 1)
          } else {
            console.log('不kong')
            // item.mobool = null
            // item.mobool = 2
            this.$set(item, 'mobool', 2)
          }
        } else {
          console.log('h5')
          this.$set(item, 'mobool', 1)
        }
        // console.log('jinlai')
        // item.app_id = ''
        // item.path = ''
        // item.switch = 2
        // // 判断 URL 是否包含 'externalAddress'
        // if (item.content_source_url.includes('externalAddress')) {
        //   console.log("URL 包含 'externalAddress'。")
        //   // 解析 URL
        //   const urlObj = new URL(item.content_source_url)
        //   // 提取 ID
        //   const id = urlObj.pathname.split('/').pop() // 提取 ID
        //   // 获取 path 参数
        //   const base64Path = urlObj.searchParams.get('path') // 获取 path 参数
        //   // 将 Base64 转换为正常字符串
        //   const decodedPath = decodeURIComponent(atob(base64Path))
        //   console.log('ID:', id) // 输出: ID: 12
        //   console.log('Decoded Path:', decodedPath) // 输出: 解码后的路径
        //   this.$set(item, 'app_id', id)
        //   this.$set(item, 'path', decodedPath)
        //   this.$set(item, 'switch', 1)
        //   this.$set(item, 'content_source_url', `${this.apiUrl}externalAddress/`)
        // } else {
        //   console.log("URL 不包含 'externalAddress'。")
        // }
      })
      console.log(' data.data.articles', data.data.articles)
      this.arr = data.data.articles
      this.bigtitle = data.data.title
      this.platformvalue = data.data.platform_id
      this.active = this.arr[0].id
      this.getlinktypesalllist()
      this.getlinktypesalllistwechat()
      console.log('详情', data)
      this.loading = false
    },
    // 获取链接类型
    async getlinktypesalllist() {
      console.log('this.arr[this.indexinput].item_platform_id', this.arr[this.indexinput].item_platform_id)
      const data = await getlinktypeslist({
        // platform_id: this.platformvalue
        // eslint-disable-next-line eqeqeq
        platform_id: this.platformvalue == 99 ? this.arr[this.indexinput].item_platform_id : this.platformvalue
      })
      this.linkallarr = []
      this.linkallarr = data.data
      console.log('data', data)
    },
    // 获取小程序链接类型
    async getlinktypesalllistwechat() {
      console.log('this.arr[this.indexinput].item_platform_id', this.arr[this.indexinput].item_platform_id)
      const data = await getlinktypeslist({
        // eslint-disable-next-line eqeqeq
        platform_id: this.platformvalue == 99 ? this.arr[this.indexinput].item_platform_id : this.platformvalue,
        mini_program: 1
      })
      this.wechatlinkallarr = []
      this.wechatlinkallarr = data.data
      console.log('data', data)
    },
    // 清空数组里面选择的书
    claerarr() {
      this.arr.forEach((item) => {
        item.book_title = ''
        item.book_id = null
        item.gender = null
        item.bookids = null
        item.chapter_name = ''
        item.chapterid = null
        item.chapteridx = null
        item.next_chapters_id = null
        item.next_chapters_name = '' // 下一章章节名称
        item.next_chapters_url = 2
        item.bottom_qr_code = 2
      })
    },
    sewrwx() {
      this.arr[this.indexinput].content_source_url = ''
      this.arr[this.indexinput].switch = 2
      this.arr[this.indexinput].original_link_type = 1
      this.arr[this.indexinput].original_link_mini_program_id = ''
      this.arr[this.indexinput].original_link_mini_program_path = ''
      this.arr[this.indexinput].mobool = 1
      this.getlinktypesalllist()
      this.getlinktypesalllistwechat()
      // 清空文章
      // this.arr[this.indexinput].content = ''
      // 清除所选书籍和章节
      this.obj.bookname = ''
      this.obj.bookid = null
      this.obj.gender = null
      this.obj.bookids = null
      this.obj.chaptername = ''
      this.obj.chapterid = null
      this.obj.chapteridx = null
      // 清空数组里面所选的书
      this.claerarr()
    },
    plateall(val) {
      console.log('val', val)
      // 清空添加链接活动数组
      this.linkallarr = []
      // eslint-disable-next-line eqeqeq
      if (val == 99) {
        console.log('通用')
      } else {
        console.log('常规')
        this.getlinktypesalllist()
        this.getlinktypesalllistwechat()
      }
      this.arr.forEach((item) => {
        // 清空原文链接
        item.content_source_url = ''
        item.switch = 2
        // 清空内容
        // item.content = ''
        // 清空选择的子平台
        item.item_platform_id = ''
        item.original_link_type = 1
        item.original_link_mini_program_id = ''
        item.original_link_mini_program_path = ''
        item.mobool = 1
      })
      // 清除所选书籍和章节
      this.obj.bookname = ''
      this.obj.bookid = null
      this.obj.gender = null
      this.obj.bookids = null
      this.obj.chaptername = ''
      this.obj.chapterid = null
      this.obj.chapteridx = null
      // 清空数组里面所选的书
      this.claerarr()
    },
    beforeHandleCommand(sign, identification, custom) {
      return {
        'sign': sign,
        'identification': identification,
        'custom': custom
      }
    },
    // 获取平台
    async getPlatform() {
      const data = await strategyPlatform()
      this.options = data.data.list
    },
    // 获取平台
    async getPlatformr() {
      const data = await strategyPlatformtwo()
      this.palarr = data.data.list
    },
    choosebookid() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        // eslint-disable-next-line eqeqeq
        this.$refs.chooseviewr.send(this.platformvalue == 99 ? this.arr[this.indexinput].item_platform_id : this.platformvalue)
      })
    },
    chapterclick() {
      this.chapterdialogVisibler = true
      this.$nextTick(() => {
        // eslint-disable-next-line eqeqeq
        this.$refs.chapterviewr.send(this.platformvalue == 99 ? this.arr[this.indexinput].item_platform_id : this.platformvalue, this.obj.bookids)
      })
    },
    // chooseplate() {
    //   this.obj.bookname = ''
    //   this.obj.bookid = null
    //   this.obj.bookids = null
    //   this.obj.chaptername = ''
    //   this.obj.chapterid = null
    // },
    bookcallbackr(val) {
      console.log('val', val)
      this.dialogVisibler = false
      this.obj.bookname = val.book_title
      this.obj.bookid = val.book_id
      this.obj.bookids = val.id
      this.obj.gender = val.gender
      // 清空上次选择的章节
      this.obj.chaptername = ''
      this.obj.chapterid = null
      this.obj.chapteridx = null

      // 数组里面的值
      this.arr[this.indexinput].book_title = val.book_title
      this.arr[this.indexinput].book_id = val.book_id
      this.arr[this.indexinput].bookids = val.id
      this.arr[this.indexinput].gender = val.gender
      // 清空数组上次选择章节
      this.arr[this.indexinput].chapter_name = null// 章节名称
      this.arr[this.indexinput].chapters_id = null// 章节id
      this.arr[this.indexinput].chapteridx = null
      this.arr[this.indexinput].next_chapters_id = null// 下一章节id
      this.arr[this.indexinput].next_chapters_name = ''// 下一章节名称
    },

    bookchaptercallback(val, next_chapters_id, next_chapters_name) {
      console.log('章节val', val, next_chapters_id, next_chapters_name)
      this.chapterdialogVisibler = false

      this.obj.chaptername = val.chapter_name
      this.obj.chapterid = val.chapter_id
      this.obj.chapteridx = val.chapter_idx

      // 数组里面的值
      this.arr[this.indexinput].chapter_name = val.chapter_name // 章节名称
      this.arr[this.indexinput].chapters_id = val.chapter_id // 章节id
      this.arr[this.indexinput].chapteridx = val.chapter_idx // 章节idx
      // eslint-disable-next-line eqeqeq
      if (this.arr[this.indexinput].chapter_typer == 1) {
        this.arr[this.indexinput].next_chapters_id = val.chapter_id// 本章章节id
        this.arr[this.indexinput].next_chapters_name = val.chapter_name// 本章节名称
      } else {
        this.arr[this.indexinput].next_chapters_id = next_chapters_id// 下一章节id
        this.arr[this.indexinput].next_chapters_name = next_chapters_name// 下一章节名称
      }
    },
    // 点击底部图片选择
    choosebottom(item, index) {
      this.whichIndex = index
      this.arr[this.indexinput].bottomitensrc = item.template_image_url
      this.arr[this.indexinput].template_image_id = item.template_image_id
    },
    async choserauth(type) {
      // if (this.arr[this.indexinput].item_platform_id === '') {
      //   this.$message.error('请选择平台')
      //   return
      // }
      // eslint-disable-next-line eqeqeq
      if (this.platformvalue == 99) {
        if (this.arr[this.indexinput].item_platform_id === '') {
          this.$message.error('请选择子平台')
          return
        }
      } else {
        if (this.platformvalue === null) {
          this.$message.error('请选择平台')
          return
        }
      }
      if (this.obj.bookid === null) {
        this.$message.error('请选择书籍')
        return
      }
      if (this.obj.chapterid === null) {
        this.$message.error('请选择章节')
        return
      }
      this.choserauthtype = type
      // const data = await promotiondocument({
      //   platform_id: this.platformvalue,
      //   book_id: this.obj.bookid,
      //   chapter_id: this.obj.chapterid
      // })
      // eslint-disable-next-line eqeqeq
      if (type == 1) {
        this.dialogVisible1 = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          // eslint-disable-next-line eqeqeq
          this.$refs.sundialogview.send(this.platformvalue == 99 ? this.arr[this.indexinput].item_platform_id : this.platformvalue, this.obj.bookid, this.obj.chapterid, this.obj.gender, this.obj.chapteridx)
        }, 100)
      }
      // eslint-disable-next-line eqeqeq
      if (type == 2) {
        this.dialogVisible1 = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          // eslint-disable-next-line eqeqeq
          this.$refs.yuwendialogview.send(this.platformvalue == 99 ? this.arr[this.indexinput].item_platform_id : this.platformvalue, this.obj.bookid, this.obj.chapterid, this.obj.gender, this.obj.chapteridx)
        }, 100)
      }

      // this.iframeURL = data.data.promotion_document_link
      // Cookies.set('Token', data.data.cookie)
      // this.Cook.set('PHPSESSID', data.data.cookie, { domain: data.data.promotion_document_link })
      // this.Cook.set('PHPSESSID', data.data.cookie, { expires: 1, domain: 'admin.yifengaf.cn' })
      // window.open(data.data.promotion_document_link, '_blank')
      // console.log('data', data)
    },
    // 鼠标单击的事件
    onClick(e, editor) {
      console.log('Element clicked')
      console.log(e)
      console.log(editor)
    },
    // 清空内容
    clear() {
      this.$refs.editor.clear()
    },
    determine() {
      console.log('确定公众号')
    },
    mouseenter() {
      this.tips = true
      this.arr.forEach(item => {
        item.showtips = false
      })
    },
    mouseleave() {
      this.tips = false
    },
    // 新增图文
    addImageText() {
      this.arr.push({
        item_platform_id: '',
        id: Math.random(),
        type: 'txt',
        img: '',
        title: '标题',
        author: '',
        content: '',
        showtips: false,
        srv: '',
        thumb_media_id: '',
        digest: '',
        content_source_url: '',
        need_open_comment: 0, // 是否打开评论，0不打开(默认)，1打开
        only_fans_can_comment: 0, // 是否粉丝才可评论，0所有人可评论(默认)，1粉丝才可评论

        book_title: '', // 选择书籍的书籍名称
        chapter_name: '', // 章节名称
        bottom_qr_code: 2, // 底部图显示以及隐藏
        bottomitensrc: '', // 底部图片地址
        book_id: null, // 书籍id
        chapters_id: null, // 当前章节id
        next_chapters_id: null, // 下一章节id
        next_chapters_name: '', // 下一章节名称
        template_image_id: null, // 二维码图片id
        gender: null, // 书籍类型
        chapteridx: null,
        bookids: null,
        next_chapters_url: 2, // 使用下一章为原文链接 1 使用 2不使用
        bottom_guide: '', // 底部图片
        chapter_typer: 2,
        app_id: '',
        path: '',
        switch: 2,
        original_link_type: 1,
        original_link_mini_program_id: '',
        original_link_mini_program_path: '',
        mobool: 1
      })
      this.active = this.arr[this.arr.length - 1].id
      this.indexinput = this.arr.length - 1
      this.arr[this.indexinput].showtips = true
      // 清空链接活动数组
      // this.linkallarr = []
      // eslint-disable-next-line eqeqeq
      if (this.platformvalue == 99) {
        if (this.arr[this.indexinput].item_platform_id === '') {
          this.linkallarr = []
        }
      }
      // 清除所选书籍和章节
      this.obj.bookname = ''
      this.obj.bookid = null
      this.obj.gender = null
      this.obj.bookids = null
      this.obj.chaptername = ''
      this.obj.chapterid = null
      this.obj.chapteridx = null

      this.whichIndex = -1
    },
    // 新增视频消息
    addvideo() {
      this.videodialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.videodialog.send(1)
      }, 100)
    },
    // 新增音频消息
    addvoice() {
      this.voicedialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.voicedialog.voicesend(1)
      }, 100)
    },
    // 新增音频消息回调
    btnclcik(item) {
      // this.editor.dangerouslyInsertHtml(`<p><video height=200 width=200 src="https://ziyuan.jingxuansz.com/user/yr1hys--%E6%99%B4%E5%A4%A9.mp3" frameborder=0 allowfullscreen="true"></video></p>`)
      this.voicedialogVisible = false
      console.log('回调', item)
      if (item.numtype === 1) {
        console.log('回调1', item.numtype)
        this.arr.push({
          id: Math.random(),
          type: 'voice',
          title: item.path.slice(item.path.indexOf('--') + 2, item.path.indexOf('.mp3')),
          recommend: '',
          voiceurl: item.path,
          showtips: false,
          srv: 'https://ziyuan.jingxuansz.com/user/yk3qmi--下载.png'
        })
        this.active = this.arr[this.arr.length - 1].id
        this.indexinput = this.arr.length - 1
        this.arr[this.indexinput].showtips = true
      } else {
        console.log('回调2', item.path)
        // this.editor.focus(true)
        this.editor.restoreSelection()
        this.editor.dangerouslyInsertHtml(`<p><video src="${item.path}"></video></p>`)
        // this.editor.dangerouslyInsertHtml(`<p><audio src="${item.path}" controls loop="loop" autoplay="autoplay"></audio></p>`)
      }
    },
    // 新增视频
    activeclick(id, index) {
      this.active = id
      this.indexinput = index
      this.arr.forEach(item => {
        item.showtips = false
      })
      this.arr[index].showtips = true
      // eslint-disable-next-line eqeqeq
      if (this.platformvalue == 99) {
        if (this.arr[this.indexinput].item_platform_id === '') {
          this.linkallarr = []
        }
      }
      // 清空添加链接活动数组
      // this.linkallarr = []
      // 有平台重新请求添加链接活动数组
      if (this.arr[this.indexinput].item_platform_id !== '') {
        this.getlinktypesalllist()
        this.getlinktypesalllistwechat()
      }
      // 清除所选书籍和章节
      this.obj.bookname = ''
      this.obj.bookid = null
      this.obj.gender = null
      this.obj.bookids = null
      this.obj.chaptername = ''
      this.obj.chapterid = null
      this.obj.chapteridx = null

      this.obj.bookname = this.arr[this.indexinput].book_title === null ? '' : this.arr[this.indexinput].book_title
      this.obj.bookid = this.arr[this.indexinput].book_id
      this.obj.gender = this.arr[this.indexinput].gender
      this.obj.bookids = this.arr[this.indexinput].bookids
      this.obj.chaptername = this.arr[this.indexinput].chapter_name === null ? '' : this.arr[this.indexinput].chapter_name
      this.obj.chapterid = this.arr[this.indexinput].chapters_id
      this.obj.chapteridx = this.arr[this.indexinput].chapteridx
      this.weizhi()
    },
    weizhi() {
      const indexs = this.bottomarr.findIndex(item => {
        // eslint-disable-next-line eqeqeq
        return item.template_image_id == this.arr[this.indexinput].template_image_id
      })
      if (indexs === -1) {
        console.log('不存在')
        this.whichIndex = -1
      } else {
        this.whichIndex = indexs
      }
    },
    choseqrcode() {
      this.weizhi()
    },
    handtipshow() {
      if (document.querySelector('.ciclebox')) { // 先判断下，不然会报错
        this.$nextTick(() => {
          this.arr.forEach(item => {
            item.showtips = false
          })
        })
      }
    },
    deleteitem(index) {
      this.arr.splice(index, 1)
      this.indexinput = index - 1
      this.active = this.arr[index - 1].id
    },
    upGo(index) {
      if (index !== 0) {
        this.arr[index] = this.arr.splice(index - 1, 1, this.arr[index])[0]
        this.indexinput = index - 1
        this.active = this.arr[index - 1].id
        console.log('111', index)
        console.log('arr', this.arr)
      } else {
        this.arr.push(this.arr.shift())
        console.log('222')
      }
    },
    downGo(index) {
      if (index !== this.arr.length - 1) {
        this.arr[index] = this.arr.splice(index + 1, 1, this.arr[index])[0]
        this.indexinput = index + 1
        this.active = this.arr[index + 1].id
        console.log('333')
      } else {
        console.log('444')
        this.arr.unshift(this.arr.splice(index, 1)[0])
      }
    },
    async go() {
      if (this.bigtitle === '') {
        this.$message.error('请输入列表标题')
        return
      }
      // if (this.platformvalue === null) {
      //   this.$message.error('请选择平台')
      //   return
      // }

      for (let i = 0; i < this.arr.length; i++) {
        if (this.arr[i].title === '') {
          this.$message.error('请输入标题')
          return
        }
        // eslint-disable-next-line eqeqeq
        // if (this.arr[i].content == '<p><br></p>') {
        //   this.$message.error('请输入文章内容')
        //   return
        // }
        if (this.arr[i].switch === 1) {
          // eslint-disable-next-line eqeqeq
          if (this.arr[i].app_id == '') {
            this.$message.error('请输入h5跳小程序appid')
            return
          }
          // eslint-disable-next-line eqeqeq
          if (this.startsWithWx(this.arr[i].app_id) == false) {
            this.$message.error('请输入正确的h5跳小程序appid')
            return
          }
          // eslint-disable-next-line eqeqeq
          if (this.arr[i].path == '') {
            this.$message.error('请输入h5跳小程序地址')
            return
          }
        }
        const invalidItems = this.arr.filter(item => {
          // eslint-disable-next-line eqeqeq
          return item.original_link_type == 2 &&
         // eslint-disable-next-line eqeqeq
         item.mobool == 2 &&
         !item.original_link_mini_program_id
        })

        if (invalidItems.length > 0) {
          this.$message.error('请填写小程序appid（小程序务必授权在运营系统）')
          return
        }
        // eslint-disable-next-line eqeqeq
        if (this.arr[i].thumb_media_id == '') {
          this.$message.error('请上传封面')
          return
        }
      }
      const arrs = []
      this.arr.forEach((item) => {
        console.log(item.content, 'item.content')
        if (item.bottom_qr_code === 2) {
          arrs.push({ item_platform_id: item.item_platform_id, id: item.id, type: item.type, img: item.img, title: item.title, author: item.author,
            content: item.content.replace(/<a(.*?)style="[^"]*"(.*?)><img[^>]*><\/a>/gi, (match, p1, p2) => { return `<a${p1}${p2}><img${match.split('<img')[1]}` }),
            showtips: item.showtips,
            srv: item.srv,
            thumb_media_id: item.thumb_media_id,
            digest: item.digest,
            content_source_url: item.original_link_type === 1 ? item.content_source_url : '',
            need_open_comment: item.need_open_comment, only_fans_can_comment: item.only_fans_can_comment,
            book_title: item.book_title, chapter_name: item.chapter_name, bottom_qr_code: item.bottom_qr_code,
            bottomitensrc: '', book_id: item.book_id, chapters_id: item.chapters_id, next_chapters_id: item.next_chapters_id, next_chapters_name: item.next_chapters_name, template_image_id: null, gender: item.gender, chapteridx: item.chapteridx, bookids: item.bookids, next_chapters_url: item.next_chapters_url, bottom_guide: item.bottom_guide, chapter_typer: item.chapter_typer, original_link_type: item.original_link_type, original_link_mini_program_id: item.original_link_type === 1 ? '' : item.original_link_mini_program_id, original_link_mini_program_path: item.original_link_type === 1 ? '' : item.original_link_mini_program_path })
        } else {
          // if(item.chapter_typer == 2 && item.next_chapters_url == 1){
          //   item.next_chapters_id =
          // }
          arrs.push({
            item_platform_id: item.item_platform_id, id: item.id, type: item.type, img: item.img, title: item.title, author: item.author,
            content: item.content, showtips: item.showtips, srv: item.srv, thumb_media_id: item.thumb_media_id, digest: item.digest, content_source_url: item.original_link_type === 1 ? item.content_source_url : '',
            need_open_comment: item.need_open_comment, only_fans_can_comment: item.only_fans_can_comment, book_title: item.book_title, chapter_name: item.chapter_name, bottom_qr_code: item.bottom_qr_code, bottomitensrc: item.bottomitensrc, book_id: item.book_id, chapters_id: item.chapters_id, next_chapters_id: item.next_chapters_id,
            next_chapters_name: item.next_chapters_name, template_image_id: item.template_image_id, gender: item.gender, chapteridx: item.chapteridx, bookids: item.bookids, next_chapters_url: item.next_chapters_url,
            bottom_guide: item.bottom_guide, chapter_typer: item.chapter_typer,
            original_link_type: item.original_link_type,
            original_link_mini_program_id: item.original_link_type === 1 ? '' : item.original_link_mini_program_id,
            original_link_mini_program_path: item.original_link_type === 1 ? '' : item.original_link_mini_program_path
          })
          // arrs.push(item)
        }
      })
      console.log('this.arrs', arrs)
      // edittype: null// false编辑 true新增
      if (this.edittype) {
        // 新增
        const data = await officialaccount({
          title: this.bigtitle,
          platform_id: this.platformvalue,
          articles: arrs
        })
        this.$message({
          type: 'success',
          message: '新增成功!'
        })
        this.$router.push({ path: '/offiaccountemlist/index' })
        console.log('data', data)
      } else {
        //  编辑
        const datar = await editaccount({
          title: this.bigtitle,
          articles: arrs,
          platform_id: this.platformvalue,
          id: this.editid
        })
        this.$message({
          type: 'success',
          message: '修改成功!'
        })
        this.$router.push({ path: '/offiaccountemlist/index' })
        console.log('datar', datar)
      }
    },
    startsWithWx(str) {
      // 使用正则表达式检查字符串是否以 "wx" 开头
      const regex = /^wx/
      return regex.test(str)
    },
    chooseiconclcik() {
      this.dialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.mychild.send(2, 0)
      }, 100)
    },
    clickicon(img) {
      console.log('img', img)
      this.dialogVisible = false
      // 这个是直接选
      this.arr[this.indexinput].srv = img.path
      this.arr[this.indexinput].thumb_media_id = img.id

      // 下面是裁剪的逻辑
      // this.caidialogVisible = true
      // const imgname = img.split('/')// 分割url
      // const imgnamer = imgname[imgname.length - 1]
      // console.log('imgnamer', imgnamer)
      // this.name = imgnamer
      // this.$nextTick(() => {
      //   this.option.img = img
      // })
      // console.log('img', img)
    },
    // 获取七牛token
    async getQiniuToken() {
      const data = await qiniuToken()
      this.token = data.data.upToken
    },
    // 截图成功上传图片
    finish() {
      this.$refs.cropper.getCropBlob((data, val) => {
        console.log('data', data)
        var sizebig = data.size
        const observable = qiniu.upload(data, `workwechat_avatar/${Math.random().toString(36).slice(-6) + '--' + this.name}`, this.token, {
          fname: this.name // 文件名
        }, {
          useCdnDomain: true // cdn域名加速
        })
        observable.subscribe({
          next() { },
          error(err) {
            console.log(err)
          },
          complete: (data) => {
            console.log('上传图片data', data, this.option.autoCropWidth, this.option.autoCropHeight)
            // this.arr[this.indexinput].srv = `https://ziyuan.jingxuansz.com/${data.key}`
            newMaterial({
              type: 1,
              height: 201,
              width: 204,
              size: sizebig,
              key: data.key
            }).then(response => {
              console.log('response', response)
              this.arr[this.indexinput].srv = response.data.path
              this.arr[this.indexinput].thumb_media_id = response.data.sourceMaterialId
              this.$message({
                message: '上传成功',
                type: 'success'
              })
            })
            this.caidialogVisible = false
          }
        })
      })
    },
    quxiao() {
      this.caidialogVisible = false
    },
    async uploadPictures(e) {
      const editor = this.editor
      const fileIfon = e.target.files[0]
      const img = new Image()
      const temporary = window.URL.createObjectURL(fileIfon)
      img.src = temporary
      this.temporary = temporary
      const observable = qiniu.upload(fileIfon, `user/${Math.random().toString(36).slice(-6) + '--' + fileIfon.name}`, this.token, {
        fname: fileIfon.name // 文件名
      }, {
        useCdnDomain: true // cdn域名加速
      })
      observable.subscribe({
        next() { },
        error(err) {
          console.log(err)
        },
        complete: (data) => {
          newMaterial({
            type: 1,
            height: img.height,
            width: img.width,
            size: fileIfon.size,
            key: data.key
          }).then(res => {
            console.log('res', res)
            editor.dangerouslyInsertHtml(`<img src="${res.data.path}">`)
          })
        }

      })
    },
    choosevideos() {
      // 富文本选择视频
      this.videodialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.videodialog.send(2)
      }, 100)
    },
    // 选择视频的回调
    callvideo(videoobj) {
      this.videodialogVisible = false
      console.log('callvideo', videoobj)
      // 添加到富文本里面
      if (videoobj.num === 2) {
        this.editor.dangerouslyInsertHtml(`<p><video height=200 width=200 src="${videoobj.videosrc}" frameborder=0 allowfullscreen="true"></video></p>`)
        this.editor.focus(true)
      }
    },
    // 富文本选择音频
    choosevoices() {
      this.voicedialogVisible = true
      setTimeout(() => { this.$refs.voicedialog.voicesend(2) }, 100)
    },
    // 编辑器的方法
    onCreated(editor) {
      this.editor = Object.seal(editor) // 【注意】一定要用 Object.seal() 否则会报错
    },
    onChange(editor) {
      console.log('onChange', editor.getHtml()) // onChange 时获取编辑器最新内容
    },
    insertTextHandler() {
      const editor = this.editor
      if (editor == null) return
      editor.insertText(' hello ')
    },
    printEditorHtml() {
      const editor = this.editor
      if (editor == null) return
      console.log(editor.getHtml())
    },
    disableHandler() {
      const editor = this.editor
      if (editor == null) return
      editor.disable()
    },
    update(file, insertFn) {
      console.log(file, insertFn)
      const url = URL.createObjectURL(file)
      console.log(url)
      this.src = url
      insertFn(url)
    },
    radiochangew(val) {
      console.log('val', val)
      // eslint-disable-next-line eqeqeq
      if (val == 1) {
        // 封面2.35 1 [2.35, 1]
        this.option.fixedNumber = [2.35, 1]
      } else {
        // 封面1 1
        this.option.fixedNumber = [1, 1]
      }
    },
    updatapic() {
      this.dialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.mychild.send(1)
      }, 100)
    },
    clickicongon(val) {
      this.dialogVisible = false
      // const editor = this.editor
      // console.log('666', val)
      // editor.dangerouslyInsertHtml(`<img data-href="${val.id}" src="${val.path}">`)
      this.$refs.editorwangfour.send(val, 1)
    },
    chawechat() {
      // const editor = this.editor
      this.choicedialogVisible = true
      // editor.dangerouslyInsertHtml(`<a href="www.baidu.com" target="222">2222</a>`)
      // this.editor.focus(true)
    },
    callback(item, type) {
      // const editor = this.editor
      this.choicedialogVisible = false
      console.log(item, type)
      // eslint-disable-next-line eqeqeq
      if (type == 1) {
        // this.editor.focus(true)
        this.$refs.editorwangfour.send(item, 2)
        // editor.dangerouslyInsertHtml(`<a href="${item.link}" target='mini_program_type=text|type=${item.appid}|title=${item.title}|link=${item.link}'>${item.title}</a>`)
        // this.editor.focus(true)
      // eslint-disable-next-line eqeqeq
      } else if (type == 2) {
        // editor.focus(true)
        // console.log(this.encodeSearchKey(item.link))
        this.$refs.editorwangfour.send(item, 3)
        // editor.dangerouslyInsertHtml(`<img data-href="mini_program_type=img|type=${item.appid}|imgid=${item.imgid}" alt="${item.link}" src="${item.imgsrc}">`)
        // this.editor.focus(true)
      } else {
        this.$refs.editorwangfour.send(item, 4)
        // editor.focus(true)
        // editor.dangerouslyInsertHtml(`<img data-href="mini_program_type=card|type=${item.appid}|imgid=${item.imgid}|cardtitle=${item.cardinput}" alt="${item.link}" src="${item.imgsrc}">`)
      }
    },
    callbackimgs(item, type) {
      this.choicedialogVisibleimg = false
      console.log(item, type)
      // eslint-disable-next-line eqeqeq
      if (type == 1) {
        this.$refs.editorwangfour.send(item, 1)
      // eslint-disable-next-line eqeqeq
      } else if (type == 2) {
        // console.log(this.encodeSearchKey(item.link))
        this.$refs.editorwangfour.send(item, 6)
      }
    },
    encodeSearchKey(key) {
      const encodeArr = [{
        code: '%',
        encode: '%25'
      }, {
        code: '?',
        encode: '%3F'
      }, {
        code: '#',
        encode: '%23'
      }, {
        code: '&',
        encode: '%26'
      }, {
        code: '=',
        encode: '%3D'
      }]
      return key.replace(/[%?#&=]/g, ($, index, str) => {
        for (const k of encodeArr) {
          if (k.code === $) {
            return k.encode
          }
        }
      })
    },
    beforehandleCommand() {
      // eslint-disable-next-line eqeqeq
      if (this.platformvalue == 99) {
        if (this.arr[this.indexinput].item_platform_id === '') {
          this.$message.error('请选择子平台')
          return
        }
      } else {
        if (this.platformvalue === null) {
          this.$message.error('请选择平台')
          return
        }
      }
    },
    handleCommand(command) {
      console.log('command', command)
      // eslint-disable-next-line eqeqeq
      if (this.platformvalue == 99) {
        if (this.arr[this.indexinput].item_platform_id === '') {
          this.$message.error('请选择子平台')
          return
        }
      } else {
        if (this.platformvalue === null) {
          this.$message.error('请选择平台')
          return
        }
      }
      this.custom = command.custom
      // eslint-disable-next-line eqeqeq
      if (command.identification == 'platform_activity') {
        this.bookctyactivitiesVisible = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          // eslint-disable-next-line eqeqeq
          this.$refs.bookctyactivitiesbox.send(this.platformvalue == 99 ? this.arr[this.indexinput].item_platform_id : this.platformvalue, 2)
        }, 100)
      }
      // eslint-disable-next-line eqeqeq
      if (command.identification == 'red_packet_activity') {
        this.redbao = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          // eslint-disable-next-line eqeqeq
          this.$refs.chooseredbao.send(this.platformvalue == 99 ? this.arr[this.indexinput].item_platform_id : this.platformvalue, 2)
        }, 100)
      }
      // eslint-disable-next-line eqeqeq
      if (command.identification == 'platform_promotion_link') {
        this.sclink = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          // eslint-disable-next-line eqeqeq
          this.$refs.sclinkview.send(this.platformvalue == 99 ? this.arr[this.indexinput].item_platform_id : this.platformvalue)
        }, 100)
      }

      // eslint-disable-next-line eqeqeq
      if (command.identification == 'platform_book_link') {
        console.log('选择的书籍 只有小程序类型才有')
        this.bookdialivler = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          // eslint-disable-next-line eqeqeq
          this.$refs.choosebookdialogview.send(this.platformvalue == 99 ? this.arr[this.indexinput].item_platform_id : this.platformvalue)
        }, 100)
      }
      // eslint-disable-next-line eqeqeq
      if (this.custom == 1) {
        // eslint-disable-next-line eqeqeq
        if (command.identification == '') {
          this.arr[this.indexinput].content_source_url = ''
          this.arr[this.indexinput].switch = 2
          this.arr[this.indexinput].content_source_url = command.sign
        }
      } else {
        // eslint-disable-next-line eqeqeq
        if (command.identification == '') {
          this.arr[this.indexinput].original_link_mini_program_path = ''
          this.arr[this.indexinput].original_link_mini_program_path = command.sign
        }
      }
    },
    // 选择书城活动回调
    callbadwr(item, type) {
      this.bookctyactivitiesVisible = false
      // eslint-disable-next-line eqeqeq
      if (this.custom == 1) {
      // eslint-disable-next-line eqeqeq
        this.arr[this.indexinput].content_source_url = ''
        this.arr[this.indexinput].switch = 2
        this.arr[this.indexinput].content_source_url = item.sign
      } else {
        this.arr[this.indexinput].original_link_mini_program_path = ''
        this.arr[this.indexinput].original_link_mini_program_path = item.sign
      }
    },
    // 选择红包活动回调
    redcallback(item, type) {
      this.redbao = false
      // eslint-disable-next-line eqeqeq
      if (this.custom == 1) {
      // eslint-disable-next-line eqeqeq
        this.arr[this.indexinput].content_source_url = ''
        this.arr[this.indexinput].switch = 2
        this.arr[this.indexinput].content_source_url = item.sign
      } else {
        this.arr[this.indexinput].original_link_mini_program_path = ''
        this.arr[this.indexinput].original_link_mini_program_path = item.sign
      }
    },
    // 选择书城链接
    sclinkcallback(item) {
      this.sclink = false
      // eslint-disable-next-line eqeqeq
      if (this.custom == 1) {
        this.arr[this.indexinput].content_source_url = ''
        this.arr[this.indexinput].switch = 2
        this.arr[this.indexinput].content_source_url = item.sign_template_no
      } else {
        this.arr[this.indexinput].original_link_mini_program_path = ''
        this.arr[this.indexinput].original_link_mini_program_path = item.sign_template_no
      }
    },
    callbackcontent(val) {
      this.dialogVisible1 = false
      this.$refs.editorwangfour.send(val, 5)
    },
    callbacktitle(val) {
      console.log('val', val)
      this.arr[this.indexinput].title = val
    },
    callbackimg(val, id) {
      this.arr[this.indexinput].srv = val
      this.arr[this.indexinput].thumb_media_id = id
      console.log('图片地址', val)
    },
    callbackbottom(val) {
      console.log('接收底部的标签', val)
      this.arr[this.indexinput].bottom_guide = val
    },
    importclick() {
      this.importlinkdialog = true
    },
    callcloser() {
      this.importlinkdialog = false
      this.$message({
        type: 'success',
        message: '导入成功!'
      })
    },
    nextchat(val) {
      if (val === 1) {
        this.arr[this.indexinput].content_source_url = ''
        this.arr[this.indexinput].original_link_mini_program_path = ''
        this.arr[this.indexinput].original_link_mini_program_id = ''
        this.arr[this.indexinput].mobool = 1
      }
      this.arr[this.indexinput].switch = 2
    },
    deleterclick() {
      this.arr[this.indexinput].bottom_guide = ''
    },
    async chapterwer(val) {
      console.log('  this.arr[this.indexinput]', this.arr[this.indexinput])
      console.log('val', val)
      if (this.arr[this.indexinput].book_id != null && this.arr[this.indexinput].chapters_id != null) {
        if (val === 2) {
          console.log('选择下一章')
          // eslint-disable-next-line eqeqeq
          const data = await novellist({ page: 1, page_size: 10, platform_id: this.platformvalue == 99 ? this.arr[this.indexinput].item_platform_id : this.platformvalue, novel_title: this.arr[this.indexinput].book_title })
          console.log('data', data.data.data.list)
          const indexs = data.data.data.list.findIndex(item => {
            // eslint-disable-next-line eqeqeq
            return item.book_id == this.arr[this.indexinput].book_id
          })
          // eslint-disable-next-line eqeqeq
          if (indexs != -1) {
            console.log(data.data.data.list[indexs])
            const datar = await createtemplate({
              novel_id: this.obj.bookids,
              // eslint-disable-next-line eqeqeq
              platform_id: this.platformvalue == 99 ? this.arr[this.indexinput].item_platform_id : this.platformvalue
            })
            console.log('datar', datar.data.chapter)
            const indexsr = datar.data.chapter.findIndex(item => {
            // eslint-disable-next-line eqeqeq
              return item.chapter_id == this.arr[this.indexinput].chapters_id
            })
            console.log('datar.data.chapter', datar.data.chapter[indexsr + 1])
            this.arr[this.indexinput].next_chapters_id = datar.data.chapter[indexsr + 1].chapter_id
            this.arr[this.indexinput].next_chapters_name = datar.data.chapter[indexsr + 1].chapter_name
          }
        } else {
          this.arr[this.indexinput].next_chapters_id = this.arr[this.indexinput].chapters_id
          this.arr[this.indexinput].next_chapters_name = this.arr[this.indexinput].chapter_name
          console.log('本章')
        }
      }
    },
    chanswitch(val) {
      console.log('val', val)
      if (val === 1) {
        this.arr[this.indexinput].content_source_url = `${this.apiUrl}externalAddress/`
      } else {
        this.arr[this.indexinput].content_source_url = ''
      }
    },
    removeAllSpaces() {
      // 去掉输入值中的所有空格
      this.arr[this.indexinput].app_id = this.arr[this.indexinput].app_id.replace(/\s+/g, '')
    },
    removeAllSpacestwo() {
      this.arr[this.indexinput].path = this.arr[this.indexinput].path.replace(/\s+/g, '')
    },
    grounpmoll(val) {
      // eslint-disable-next-line eqeqeq
      if (val === 1) {
        this.arr[this.indexinput].original_link_mini_program_id = ''
      }
    },
    callchoooseter(str) {
      this.bookdialivler = false
      this.arr[this.indexinput].original_link_mini_program_path = ''
      this.arr[this.indexinput].original_link_mini_program_path = str
    }
  }
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped>
.opallbox{
  padding: 20px 20px 0px 20px;
  display: flex;
  flex-wrap: wrap;
}
.title_vor{
  padding: 10px 20px 20px 20px;
  color: red;
}
.optionbox{
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 15px;
}
.optiontext{
  margin-right: 10px;
  font-size: 14px;
  flex-shrink: 0;
}
.editbox{
  padding: 0 20px 0px 20px;
  display: flex;
}
.leftbox{
  width: 403px;
}
.addbox{
  width: 403px;
  height: 48px;
  border: 1px solid #f3f3f3;
  text-align: center;
  line-height: 48px;
  position: relative;
}
.updatabox{
  height: 158px;
  text-align: center;
  line-height: 158px;
  border: 1px solid #f3f3f3;
  position: relative;
}
.updatabox1{
    position: relative;
    height: 72px;
    border: 1px solid #f3f3f3;
    padding: 0 27px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.srvbox{
  width: 50px;
  height: 40px;
}
.spanbox{
  position: absolute;
  left: 18px;
  z-index: 9;
  width: 350px;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  padding-top: 30px;
  height: 130px;
  display: block;
  white-space: nowrap;

}
.spanbox1{
  position: inherit;
  left: 0;
  top: 0;
  width: 280px;
  z-index: 9;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tipbox{
  position: absolute;
  background: white;
  padding: 10px;
  position: absolute;
  top: 39px;
  left: 180px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.updataactive{
   border: 2px solid #07c160;
}
.centerbox{
  margin-left: 86px;
  width: 620px;
}
.centerinput{
  margin-bottom: 20px;
}
.ciclebox{
  padding: 15px 7px 5px 7px;
  margin: 0 7px;
  background-color: #fff;
  box-shadow: 0 1px 6px 0 #e4e8eb;
  border-radius: 25px;
  position: absolute;
  left: 430px;
  top: 50%;
  transform: translate(0, -50%);
}
.tiparrowbox{
  display: flex;
  flex-direction: column;
}
.tipicon{
  margin-bottom: 5px;
}
.tipicon{
  font-size:20px ;
  margin-bottom: 10px;
}
.chooseicon{
  width: 90px;
      height: 90px;
    box-sizing: border-box;
    border: 2px dashed #ebebeb;
    text-align: center;
    padding-top: 12px;
    position: relative;
    flex-shrink: 0;
}
.iconplus{
  color: #8f9091;
  font-size: 20px;
}
.btn-text{
  font-size: 12px;
      color: #7e8081;
      margin-top: 10px;
}
.setting-group__title{
  font-size: 16px;
    line-height: 20px;
    margin-bottom: 20px;
}
.backrbox{
width: auto;
    height: 100%;
  background-color: #e1e1e1;
    background-size: cover;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
.backrbox1{
    position: absolute;
    background-color: #e1e1e1;
        background-size: cover;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    top: 9px;
    right: 17px;
    width: 50px;
    height: 50px;
}
.select-cover__preview{
  position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
}
.abstractbox{
  width: 100%;
  display: flex;
}
.textfield{
  margin-left: 10px;
  height: 100%;
}
.cropper-content .cropper {
        width: auto;
        height: 600px;
}

audio {
  width: 100%;
  height: 50px;
  outline: none;
  filter: none;
}
.viewrw{
  margin-top: 20px;
}
.btne{
  margin-top: 20px;
}
.sdawr{
  font-size: 15px;
  margin-right: 10px;
}
.fansbox{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.chawepalite{
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.choosecover{
  display: flex;
  align-items: center;
}
 .editdraw /deep/ .el-drawer__body{
  height: 100%;
}
.bottom_box{
  height: 348px;
  width: 480px;
  overflow-y:scroll;
  margin-left: 20px;
  display: flex;
  flex-wrap: wrap;
}
.bottom_itembox{
  width: 220px;
  height: 90px;
  margin-right: 10px;
}
.bottom_qrcode{
  width: 616px;
  margin-bottom: 10px;
}
.bottom_Light{
  border: 2px solid #F56C6C;
}
.delter_icon{
  position: absolute;
  top: 9px;
  right: 10px;
}
.delter_icon i {
  font-size: 20px;
  cursor:pointer;
}
@media (max-width: 768px){
  .editbox{
    flex-direction: column;
  }
  .centerbox{
    width:100%;
    margin:0px;
    margin-top:20vw;
  }
}
</style>
